var map = {
	"./de/kv.jpg": "zwiv",
	"./en/kv.jpg": "lSBz",
	"./es/kv.jpg": "kz/m",
	"./fr/kv.jpg": "zhpn",
	"./ja/kv.jpg": "1SVl",
	"./ko/kv.jpg": "l+73",
	"./pt/kv.jpg": "Xxg9",
	"./ru/kv.jpg": "xGrG",
	"./th/kv.jpg": "qJQF",
	"./zh-Hant/kv.jpg": "swgq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "j6wA";